/* global HTMLElement */ import React from "react";
import ReactDOMServer from "react-dom/server";
import classNames from "classnames";
import ProgressDisplay from "../ProgressDisplay";
function emulateChapter(node, element, props) {
    var disableProgressIndicator = element.classList.contains("slide-link-emulated__disableProgressIndicator");
    var disableSubheader = element.classList.contains("slide-link-emulated__disableSubheader");
    var classes = classNames("title", {
        "chapter-do-not-track": node.do_not_track,
        "chapter-not-available": !props.isChapterAvailable
    });
    var alternativeTitle = node.alt.trim() || "".concat(props.intl.formatMessage({
        id: "ui.chapter",
        defaultMessage: "Chapter"
    }), " ").concat(props.chapterIndex.join("."));
    var chapterNode = /*#__PURE__*/ React.createElement("div", {
        className: "chart-menu open",
        tabIndex: 0
    }, /*#__PURE__*/ React.createElement("div", {
        className: "app-menu__chapter"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes,
        "data-testid": "chapter-wrapper"
    }, !!node.id && !node.do_not_track && !!props.trackableSlidesCount && !disableProgressIndicator && /*#__PURE__*/ React.createElement(ProgressDisplay, {
        compact: true,
        maxVal: props.trackableSlidesCount,
        val: props.trackableCompletedSlidesCount
    }), /*#__PURE__*/ React.createElement("div", {
        className: "title-wrapper"
    }, !disableSubheader && /*#__PURE__*/ React.createElement("span", {
        className: "title-super"
    }, alternativeTitle), /*#__PURE__*/ React.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: node.name
        }
    })))));
    element.innerHTML = ReactDOMServer.renderToString(chapterNode);
}
export default emulateChapter;
